export default __webpack_public_path__ + "static/media/fileppt.fcec49e7.svg";